import React from "react";
const icon = (
  <svg
    width="384"
    height="512"
    viewBox="0 0 384 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_60)">
      <path
        d="M280 64H320C355.3 64 384 92.7 384 128V448C384 483.3 355.3 512 320 512H64C28.7 512 0 483.3 0 448V128C0 92.7 28.7 64 64 64H104H113.6C121 27.5 153.3 0 192 0C230.7 0 263 27.5 270.4 64H280ZM64 112C55.2 112 48 119.2 48 128V448C48 456.8 55.2 464 64 464H320C328.8 464 336 456.8 336 448V128C336 119.2 328.8 112 320 112H304V136C304 149.3 293.3 160 280 160H192H104C90.7 160 80 149.3 80 136V112H64ZM192 104C198.365 104 204.47 101.471 208.971 96.9706C213.471 92.4697 216 86.3652 216 80C216 73.6348 213.471 67.5303 208.971 63.0294C204.47 58.5286 198.365 56 192 56C185.635 56 179.53 58.5286 175.029 63.0294C170.529 67.5303 168 73.6348 168 80C168 86.3652 170.529 92.4697 175.029 96.9706C179.53 101.471 185.635 104 192 104Z"
        fill="#8803E9"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_60">
        <rect width="384" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default icon;
